var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuDotsVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_2933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 4C13.1046 4 14.0001 3.10457 14.0001 2C14.0001 0.89543 13.1046 0 12.0001 0C10.8955 0 10.0001 0.89543 10.0001 2C10.0001 3.10457 10.8955 4 12.0001 4Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 14.0003C13.1046 14.0003 14.0001 13.1049 14.0001 12.0003C14.0001 10.8957 13.1046 10.0003 12.0001 10.0003C10.8955 10.0003 10.0001 10.8957 10.0001 12.0003C10.0001 13.1049 10.8955 14.0003 12.0001 14.0003Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 23.9997C13.1046 23.9997 14.0001 23.1043 14.0001 21.9997C14.0001 20.8951 13.1046 19.9997 12.0001 19.9997C10.8955 19.9997 10.0001 20.8951 10.0001 21.9997C10.0001 23.1043 10.8955 23.9997 12.0001 23.9997Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_2933"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDotsVertical);
export default __webpack_public_path__ + "static/media/menu-dots-vertical.39ab9f40413475bfd5d729ae0d0c9cbb.svg";
export { ForwardRef as ReactComponent };